<div [class]="cssClass()">
  @for (card of cards(); track $index) {
    <ds-card-item [data]="card" />
  }
</div>
